import { render, staticRenderFns } from "./ThemeConfig.vue?vue&type=template&id=1b4d0fec&scoped=true"
import script from "./ThemeConfig.vue?vue&type=script&lang=js"
export * from "./ThemeConfig.vue?vue&type=script&lang=js"
import style0 from "./ThemeConfig.vue?vue&type=style&index=0&id=1b4d0fec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b4d0fec",
  null
  
)

export default component.exports